import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductContentsSection } from './components/ProductContentsSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { UpsellSection } from './components/UpsellSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostOfNotBuyingSection } from './components/CostOfNotBuyingSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/SectionDivider';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const pixelScript = document.createElement('script');
      pixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1934048370513297');
        fbq('track', 'PageView');
      `;
      document.head.insertBefore(pixelScript, document.head.firstChild);
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1934048370513297&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return <div className="min-h-screen w-full font-sans selection:bg-brand-gold selection:text-black overflow-x-hidden" data-id="element-0">
      <SocialProofToast data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SectionDivider data-id="element-3" />
      <PainPointsSection data-id="element-4" />
      <SectionDivider data-id="element-5" />
      <ProductContentsSection data-id="element-6" />
      <SectionDivider data-id="element-7" />
      <BonusesSection data-id="element-8" />
      <SectionDivider data-id="element-9" />
      <UrgencySection data-id="element-10" />
      <SectionDivider data-id="element-11" />
      <PricingSection data-id="element-12" />
      <SectionDivider data-id="element-13" />
      <UpsellSection data-id="element-14" />
      <SectionDivider data-id="element-15" />
      <TestimonialsSection data-id="element-16" />
      <SectionDivider data-id="element-17" />
      <GuaranteeSection data-id="element-18" />
      <SectionDivider data-id="element-19" />
      <FAQSection data-id="element-20" />
      <SectionDivider data-id="element-21" />
      <CostOfNotBuyingSection data-id="element-22" />
      <SectionDivider data-id="element-23" />
      <FinalCTASection data-id="element-24" />
      <Footer data-id="element-25" />
    </div>;
}